export default __webpack_public_path__ + "/images/lightbulb_head.png";